import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';

import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';

import HomeIcon from '@material-ui/icons/Home';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTranslation } from 'next-i18next';
import ButtonLink from '../links/ButtonLink';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    backgroundColor: theme.palette.primary.extralight,
  },
}));

interface Props {
  links: {
    href: string;
    i18nKey: string;
    verbatim: boolean;
  }[];
  currentItem: {
    i18nKey: string;
    verbatim: boolean;
  };
}

const defaultProps = {};

const BreadCrumbs: React.FC<Props> = ({ links, currentItem }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  return (
    <div className={classes.root}>
      <Container>
        <Breadcrumbs aria-label="breadcrumb" separator={<ChevronRightIcon />}>
          <ButtonLink href="/feed">
            <HomeIcon />
          </ButtonLink>
          {links.map((link) => (
            <ButtonLink key={link.href} href={link.href} color="primary">
              {link.verbatim
                ? link.i18nKey
                : t(`breadcrumbs.${link.i18nKey}` as const)}
            </ButtonLink>
          ))}
          <Button color="primary" variant="outlined">
            {currentItem.verbatim
              ? currentItem.i18nKey
              : t(`breadcrumbs.${currentItem.i18nKey}` as const)}
          </Button>
        </Breadcrumbs>
      </Container>
    </div>
  );
};

BreadCrumbs.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default BreadCrumbs;
